if (!customElements.get('custom-blog-posts')) {
  customElements.define(
    'custom-blog-posts',
    class CustomBlogPosts extends HTMLElement {
      constructor() {
        super();

        //states
        this.isLayoutFeatured = this.dataset.layoutStyle === 'latest_featured';
        this.aspectRatio = this.dataset.aspectRatio;
        this.imageConstrained = this.dataset.imageConstrained;
        this.articlesAmount = this.dataset.articlesAmount;
        this.currentCursor = '';
        this.hasNextPage = true;
        this.hasPreviousPage = false;

        //elements
        this.blogArticlesBlock = this.querySelector('.blog__articles');
        this.loadMoreBtn = this.querySelector('.blog__loadmore-btn');
        this.blogLoader = this.querySelector('.blog__loader');
        this.errorMessage = this.querySelector('.blog__error-message');

        //eventListeners
        this.loadMoreBtn.addEventListener('click',() => this.fetchArticles())
      }

      connectedCallback() {
        this.fetchArticles()
      }

      fetchArticles() {
        this.loadMoreBtn.classList.add('bttn--loading');
        try {
          fetch(`https://hulken.ai/api/articles?articlesAmount=${this.articlesAmount}&cursor=${this.currentCursor}`)
            .then(res => res.json())
            .then(({articles}) => {
              this.renderArticles(articles.edges);

              this.currentCursor = articles.pageInfo.endCursor;

              if(!articles.pageInfo.hasNextPage) {
                this.loadMoreBtn.classList.add('blog-hidden');
              } else {
                this.loadMoreBtn.classList.remove('blog-hidden');
              }
            })
            .finally(() => {
              this.loadMoreBtn.classList.remove('bttn--loading');
              this.errorMessage.classList.add('blog-hidden');
              !this.blogLoader.classList.contains('blog-hidden') && this.blogLoader.classList.add('blog-hidden');
            })
        } catch (error) {
          this.loadMoreBtn.classList.add('blog-hidden');
          this.errorMessage.classList.remove('blog-hidden');
          console.error(error.message)
        }
      }

      renderArticles(articles) {
        articles.map((articleNode, index) => {
          const articleClasses = [];
          const article = articleNode.node;

          if(index === 0 && this.isLayoutFeatured) {
            articleClasses.push('is-featured')
          }

          if(article.image?.url != null) {
            articleClasses.push('has-image')
          }
          this.blogArticlesBlock.insertAdjacentHTML("beforeend",
            `
              <article class="blog__article relative ${articleClasses.join(' ')}">
                <a href="${article.onlineStoreUrl}">
                  <div class="blog__article-image blog__article-image--aspect-ratio-${this.aspectRatio}">
                    <div class="blog__article-image-constraint">
                      <div class="image image--animate">
                        <img
                          class="image__img lazyload"
                          fetchpriority="auto"
                          src="${article.image?.url}"
                          data-widths="[720, 900, 1080, 1296, 1512, 1728, 2048]"
                          data-sizes="auto"
                          alt="${article.image?.altText || 'blog-image'}"
                        >
                      </div>
                    </div>
                  </div>

                  ${ (index === 0  && this.isLayoutFeatured)
                    ? `<div class="blog__article-featured-badge ttu lh-title bg-accent white">
                        Featured
                      </div>`
                    : ''
                  }
                </a>
                <div class="blog__article-content">
                  <h2 class="blog__article-title blog__article-heading type-heading-1-small">
                    <a href="${article.onlineStoreUrl}">${article.title}</a>
                  </h2>
                  <div class="blog__article-excerpt type-body-regular mt3">
                    ${article.content}
                  </div>
                  <a href="${article.onlineStoreUrl}" class="bttn bttn--secondary bttn--inline mt4">
                    Read more
                  </a>
                </div>
              </article>
            `
          )

          this.isLayoutFeatured = false;
        })
      }
    }
  )
}

